import {
  APPEND_PID,
  SET_UPLOAD_MODAL_OPTIONS,
  SET_LOADING,
  UPLOAD_MODAL_SET_APPEND_TYPE,
  SET_STEPPER_DATA_SOURCE,
  SET_UPDATING_TARGET,
  SET_INITIAL_TARGET_ACTION,
  SET_INITIAL_TARGET,
  IS_DIGITAL,
  SET_SHOW_MODAL_STEPPER,
  SET_INTENTS,
  GET_DEMOS,
} from './actions'

const mutations = {
  [SET_UPLOAD_MODAL_OPTIONS]: (state, options) => {
    state.uploadModalOptions = options
  },
  [APPEND_PID]: (state) => {
    if (!state.appendPidOption) {
      state.appendPidOption = 1
    } else {
      state.appendPidOption = state.appendPidOption + 1
    }
  },
  [SET_SHOW_MODAL_STEPPER]: (state, payload) => {
    let target
    let step = null
    if (payload.target) {
      target = payload.target
    }
    if (payload.step !== undefined) {
      step = payload.step
    }
    state.initialTarget = target

    // TODO: Make `2` point to a constant
    state.showStepperModal = step !== null ? step : 2
  },
  [SET_INTENTS]: (state, value) => {
    state.intents = value
  },
  [SET_LOADING]: (state, value) => {
    state.isLoading = value
  },
  [UPLOAD_MODAL_SET_APPEND_TYPE]: (state, appendType) => {
    state.appendType = appendType
  },
  [SET_INITIAL_TARGET_ACTION]: (state, option) => {
    state.initialTargetAction = option
  },
  [SET_STEPPER_DATA_SOURCE]: (state, option) => {
    state.stepperDataSourceTrigger = option
  },
  [SET_INITIAL_TARGET]: (state, target) => {
    state.initialTarget = target
  },
  [SET_UPDATING_TARGET]: (state, target) => {
    state.initialTarget = target
    state.initialTargetAction = target ? state.initialTargetAction : null
  },
  [IS_DIGITAL]: (state, value) => {
    state.is_digital = value
  },
  [GET_DEMOS] (state, value) {
    state.demos = value
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/appLogic/targets/createTarget/store/mutations.js